// @flow

import { injectGlobal } from 'styled-components'
import 'moment/locale/ja'

injectGlobal`
body, html {
	margin: 0;
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

a {
	text-decoration: none;
}

`



// WEBPACK FOOTER //
// ./src/config/init.js